import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-network-error-dialog',
  templateUrl: './network-error-dialog.component.html',
  styleUrls: ['./network-error-dialog.component.css'],
  standalone: true,
  imports: [MatDialogModule],
})
export class NetworkErrorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NetworkErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; status?: number }
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  retry(): void {
    this.dialogRef.close();
    window.location.reload();
  }
}

